import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/WebLayouts/Header';
import Footer from '../../components/WebLayouts/Footer';
import '../../components/WebLayouts/legal-pages.css';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="wrapper">
      <Header />
      <div  className="container my-5" style={{paddingTop:'100px'}}>
        <div className="legal-page">
          <h1>Privacy Policy</h1>
          
          <p>Neon Gas Nigeria ("Neon Gas," "we," "us," or "our") respects the privacy of our users ("you" or "your"). This Privacy Policy describes how we collect, use, disclose, and protect your information when you visit our website (the "Website") and use our services, including ordering gas online (the "Services").</p>
          
          <h4>1. Information We Collect</h4>
          <p>We collect several types of information from and about you when you use the Website and Services:</p>
          <ul>
            <li><strong>Personal Data:</strong> When you order gas online, we collect personal data that you provide, such as your name, phone number, email address, delivery address, and payment information.</li>
            <li><strong>Location Data:</strong> We may collect your location data, such as your IP address, to provide you with the best possible service, including displaying gas prices and delivery options relevant to your area. You can manage your location settings through your device or browser.</li>
            <li><strong>Usage Data:</strong> We may collect information about how you use the Website and Services, such as the pages you visit, the time you spend on the Website, and the searches you perform.</li>
          </ul>
          
          <h4>2. How We Use Your Information</h4>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To fulfill your orders and deliver gas to you.</li>
            <li>To send you important information about your orders, including order confirmations, delivery updates, and receipts.</li>
            <li>To provide you with customer support.</li>
            <li>To improve the Website and Services by analysing usage data.</li>
            <li>To send you promotional emails or marketing messages, with your consent.</li>
          </ul>
          
          <h4>3. Sharing Your Information</h4>
          <p>We may share your information with third-party service providers who help us operate the Website and Services, such as payment processors and delivery companies. These service providers are only authorized to use your information for the specific task for which they are hired.</p>
          <p>We may also disclose your information if required by law, such as in response to a court order or subpoena.</p>
          
          <h4>4. Data Security</h4>
          <p>We take reasonable steps to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no website or internet transmission is completely secure. We cannot guarantee the security of your information.</p>
          
          <h4>5. Your Choices</h4>
          <p>You have choices regarding your information:</p>
          <ul>
            <li>You can opt-out of receiving promotional emails from us by following the unsubscribe instructions in the emails.</li>
            <li>You can manage your location settings through your device or browser.</li>
          </ul>
          
          <h4>6. Children's Privacy</h4>
          <p>The Website and Services are not intended for children under the age of 18. We do not knowingly collect personal data from children under 18. If you are a parent or guardian and you believe your child has provided us with personal data, please contact us.</p>
          
          <h4>7. Contact Us</h4>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <ul>
            <li>By email: info@neongas.ng</li>
            <li>By phone: +2349090000130</li>
          </ul>
          
          <div className="text-center mt-4">
            <button className="btn btn-primary" onClick={goHome}>
              Back to Home
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}